import SceneView from "../views/SceneView";
import ViewManager from "../utils/ViewManager";
import {DefaultLayers} from "../utils/Layers";
import BitmapTextField from "../views/components/BitmapTextField";
import TextField from "../views/components/TextField";


export default class ClockController {

    clockScene: SceneView
    private clockField: PIXI.Text | BitmapTextField | TextField;
    private clockInterval: any;

    constructor() {
        this.clockScene = ViewManager.getLayer(DefaultLayers.Header).getCurrentScene();
        this.clockField = this.clockScene.sceneTextFields.get("clock");
        this.initTime();
        this.clockInterval = setInterval(()=> {
            this.initTime();
        }, 1000)
    }

    initTime() {
        let date = new Date();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        if (minutes < 10) {
            this.clockField.text = hours + ":0" + minutes;
        } else {
            this.clockField.text = hours + ":" + minutes;
        }

    }

    stopClockUpdate() {
        clearInterval(this.clockInterval);
    }
}
